// extracted by mini-css-extract-plugin
module.exports = {"teamMember":"TeamMember_teamMember__uLD8l","employee":"TeamMember_employee__2L1Wy","name":"TeamMember_name__1MVZ_","textCard":"TeamMember_textCard__72e6L"};